module.exports = function(service) {
	'use strict'
	service.factory('jQuery', jQueryService);
	jQueryService.$inject = ['$window'];

	function jQueryService($window) {
	   return $window.jQuery; // assumes jQuery has already been loaded on the page
	}
}


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/servicesModule/services/jQueryService.js
// module id = 610
// module chunks = 0